// extracted by mini-css-extract-plugin
export default {"badge-ecommerce__container":"styles_badge-ecommerce__container__fiBXQ","badge-ecommerce__text":"styles_badge-ecommerce__text__xfQPY"};